<template>
	<div class="contentHome">
		<div class="centerPage">
			<el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
				<el-breadcrumb-item><a href="javascript:void(0);" @click="$router.push('/' + appoint.account)" class="aHref">医生详情</a>
				</el-breadcrumb-item>
				<el-breadcrumb-item>预约订单</el-breadcrumb-item>
			</el-breadcrumb>
			<el-steps :active="active" align-center class="stepRes">
				<el-step v-for="(item,index) in titleList" :title="item.title" :key="index"></el-step>
			</el-steps>
<!--			<h3 class="statement">网站声明：您与患者的咨询不会被录音和录像；你们的交流纯属隐私，绝对保密。</h3>-->
			<div :state="userState" style="text-align: center;">对方{{ userState == 0 ? '未' : '已' }}就绪.</div>
			<div class="flex chat-comment" style="align-items: start;">
				<div class="duration-time">
					<p>预约时间:</p>
					<p>{{new Date(appoint.appointStartLongtime).Format('yyyy-MM-dd HH:mm')}}</p>
					<p>{{new Date(appoint.appointEndLongtime).Format('yyyy-MM-dd HH:mm')}}</p>
					<el-divider></el-divider>
					<p>咨询时长:</p>
					<p class="clock">{{ ((duration.hour>9)?duration.hour:('0'+duration.hour)) + ':' + ('0' + duration.minute).slice(-2) + ':' + ('0' + duration.second).slice(-2) }}</p>
					<p>
						<el-button type="primary" plain @click="remindTimeout" :loading="remind.loading">{{remind.timeout>0?(remind.timeout + 's'):''}}{{remind.text}}</el-button>
					</p>
          <p style="margin-top: 10px">
            <el-button type="primary" plain v-if="consultMode==1" @click="applyUpgrade">请求视频画面</el-button>
          </p>
				</div>
				<div class="chat-div">
					<!-- z-index: -->
					<!-- rv:1  lv: 10  ov:50  ui: 50 -->
					<div id="video-user-info">
						<div><img :src="userAvatar" alt="用户头像"></div>
						<div class="user-name"><span>{{ patientName }}</span></div>
					</div>
					<div id="local-video"></div>
					<div id="remote-video"></div>
					<div id="operate-group">
						<span v-if="state==1 && userState==1" @click="callUser" class="op call"><i class="el-icon-phone"></i></span>
						<span v-if="state==2" @click="cancelCall" class="op hangup"><i class="el-icon-phone"></i></span>
						<span v-if="state==3" @click="hangupCall" class="op hangup"><i class="el-icon-phone"></i></span>
					</div>
					<div v-if="consultMode==1 && state>1" class="mode-tips">当前语音模式</div>
					<div v-if="consultMode==2 && state<2" class="mode-tips">当前视频模式</div>
				</div>
				<div class="chatCom">
					<div class="wxchatBorderRightTop">{{ patientName }}</div>
					<div class="wxchatBorderRightMid" id="chatRecord">
						<el-row v-for="msg in msgList" :key="msg.id">
							<template v-if="msg.type == 1">
								<el-col :span="22">
									<div class="chatPop2 chatPop">
										<template v-if="msg.msgType == 'img'">
											<el-image
												style="width: 100px; height: 100px"
												:src="msg.content"
												:preview-src-list="[msg.content]"
												fit="contain"></el-image>
										</template>
										<template v-else>
											{{ msg.content }}
										</template>
									</div>
								</el-col>
								<el-col :span="2">
									<el-avatar :src="doctorAvatar" :size="27"></el-avatar>
								</el-col>
							</template>
							<template v-else>
								<el-col :span="2">
									<el-avatar :src="userAvatar" :size="27"></el-avatar>
								</el-col>
								<el-col :span="22">
									<div class="chatPop1 chatPop">
										<template v-if="msg.msgType == 'img'">
											<el-image
												style="width: 100px; height: 100px"
												:src="msg.content"
												:preview-src-list="[msg.content]"
												fit="contain"></el-image>
										</template>
										<template v-else>
											{{ msg.content }}
										</template>
									</div>
								</el-col>
							</template>
						</el-row>
					</div>
					<div class="wxchatBorderRightBottom">
						<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3}" placeholder="请输入聊天内容" v-model="msgContent"
							resize="none" autofocus maxlength="200" show-word-limit>
						</el-input>
						<div class="sendButton">
							<el-upload
								class="upload-demo"
								name="uploadFile"
								action=""
								:before-upload="handleChatImgBeforeUpload"
								accept="image/png,image/gif,image/jpg,image/jpeg"
								:show-file-list="false">
								<span class="el-icon-picture-outline upload">上传图片</span>
							</el-upload>
							<el-button @click="sendMessage">发送</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>

    <el-dialog title="用户活动检测"
               width="450px"
               top="0"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="longStayTimer.dialogShow">
      <div>页面即将刷新，返回首页，请在 <span style="font-size: 16px;color: red">{{longStayTimer.waitSecond}}</span> 秒内点击 [确定] 按钮以阻止！</div>
      <div style="text-align: right;margin-top: 18px">
        <el-button type="primary" @click="renewStayTimer" style="height: 34px; line-height: 34px; padding: 0 24px;">确定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="请求对方视频画面"
               :visible.sync="applyUpgradeDialog.show"
               width="450px"
               top="0"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <p>正在等待对方同意, 剩余时间: {{applyUpgradeDialog.expire}}s</p>
    </el-dialog>
	</div>
</template>

<script>
  import base from '@/api/common';
  import {Alert, Tooltip} from 'element-ui';
  import TRTCCalling from "trtc-calling-js";

  let isNotice = false;
  export default {
    name: "chatDoctor",
    data() {
      return {
        loading: false,
        userId: '',
        doctorId: '',
        patientName: '',// 用户名称
        userAvatar: '',// 用户头像
        doctorAvatar: '',// 医生头像
        active: 2,
        titleList: [{title: '填写订单',}, {title: '付款',}, {title: '咨询',}],
        appointId: '',// 预约id
        consultMode: 0,

        state: 0, // 0-未就绪 1-就绪 2-拨号中 3-通话中
        userState: 0,

        VueTRTCCalling: null,
        VueWebSocket: null,

        webSocketHealthInterval: 0,

        msgContent: '',
        msgList: [],

        duration :{ // 咨询时长计时器
          timer: 0,
          timestamp: 0,
          hour: 0,
          minute: 0,
          second: 0,
				},
        remind:{ // 提醒框
          initTimeoutSecond: 60, //初始值: 提醒按钮点击间隔
          timer: 0,
          text: '提醒对方即将结束',
					timeout: 0,
					loading: false,
				},
				appoint:{},

				documentHiddenState:{
          timeout: 300000,// 5分钟
          activeTimeoutTimer: 0, // 用户活动定时器
          hidden: '',
          visibilityChange: '',
          state: '',
				},

        longStayTimer: {
          INIT_WAIT_SECOND: 1800, // 允许等待的最长时间: 30min
          INIT_REMIND_SECOND: 180, // 出现弹窗提醒的时间: 3min

          waitSecond: 0,
          timer: 0, // timer ID
          dialogShow: false // 提醒弹窗
        },

        applyUpgradeDialog:{
          show: false,
          expire: 0,
          timer: 0,
        }

      }
    },
    watch: {
      msgList(val,oval){
        this.$nextTick(()=>{
          document.querySelector("#chatRecord").scrollTop = document.querySelector("#chatRecord").scrollHeight;
        })
      }
    },
    updated() {
      // 聊天定位到底部
      let ele = document.getElementById('chatRecord');
      ele.scrollTop = ele.scrollHeight;
    },
    components: {
      [Alert.name]: Alert,
      [Tooltip.name]: Tooltip
    },
    inject: ['reload'],
    async mounted() {
      let vm = this, id = vm.$route.params.id;
      let res = await this.$ajax.get(base.api.user.appointDetail.replace('{id}', id))
        .then((res) => {
          if (res.data.status === 'success') {
            vm.appointId = id;
            vm.room = res.data.data.appoint.account;
            vm.userAvatar = res.data.data.appoint.headimguser;
            vm.doctorAvatar = res.data.data.appoint.headimgdoctor;
            vm.userId = res.data.data.appoint.userId;
            vm.doctorId = res.data.data.appoint.doctorId;
            vm.consultMode = res.data.data.appoint.consultMode;
            vm.patientName = res.data.data.appoint.realName;

            vm.appoint = res.data.data.appoint;
            return true;
          } else {
            return false;
          }
        });
      if (!res) {
        return;
      }
      vm.windowUniqueness();

      vm.initWebSocket();

      window.addEventListener("beforeunload", function (e) {
        let that = this;
        that.VueTRTCCalling.hangup({
          status: 'connected'
        });
      });
      vm.duration.timestamp = 0;

      vm.addListenerForUserActive(); // 监听用户是否离开窗口标签: 无法移除监听
      this.openStayTimer();
    },
    destroyed() {
      this.destroyTrtc();
      clearInterval(this.longStayTimer.timer);
    },
    methods: {
      windowUniqueness(){

      },
      destroyTrtc(){
        try {
          this.removeListener();
          // 关闭trtc连接
          if(this.VueTRTCCalling){
            this.VueTRTCCalling.hangup(); // 挂断
            this.VueTRTCCalling.logout(); // 退出
            this.VueTRTCCalling = null;
          }
          // 断开websocket
          this.VueWebSocket.close();
        }catch (e) {
					console.error('destroyTrtc: ' + e);
        }
			},
      openStayTimer(){
        let vm = this;
        // 添加计时器: 长时间停留此窗口30min, 需刷新页面
        // 初始化时间
        if(vm.longStayTimer.timer){
          clearInterval(vm.longStayTimer.timer);
        }
        vm.longStayTimer.waitSecond = vm.longStayTimer.INIT_WAIT_SECOND;
        vm.longStayTimer.timer = setInterval(()=>{
          vm.longStayTimer.waitSecond --;
          // 弹窗提醒
          if(!vm.longStayTimer.dialogShow && vm.longStayTimer.waitSecond < vm.longStayTimer.INIT_REMIND_SECOND){
            vm.longStayTimer.dialogShow = true;
            return;
          }
          // 计时结束: 返回首页
          if(vm.longStayTimer.waitSecond <= 0){
            location.href = '/index';
          }
        },1000)

      },
      renewStayTimer(){
        this.longStayTimer.waitSecond = this.longStayTimer.INIT_WAIT_SECOND;
        this.longStayTimer.dialogShow = false;
      },
      startRecordTime(){
        // 咨询时长累加
				let vm = this;
        if(vm.duration.timer){
          clearInterval(vm.duration.timer);
        }
        vm.duration.timer = setInterval(()=>{
          vm.duration.timestamp++;
          vm.duration.second = vm.duration.timestamp % 60;
          vm.duration.minute = Math.floor(vm.duration.timestamp / 60);
          vm.duration.hour = Math.floor(vm.duration.timestamp / 3600);
        },1000);
			},
			pauseRecordTime(){
        if(this.duration.timer){
          clearInterval(this.duration.timer);
        }
        this.duration.timer = 0;
			},
			resetRecordTime(){
        this.pauseRecordTime();
        this.duration.timestamp = 0;
        this.duration.hour = 0;
        this.duration.minute = 0;
        this.duration.second = 0;
			},
      remindTimeout(){
        let that = this;
        if (that.VueWebSocket && that.VueWebSocket.readyState === 1) {
          let msg = {
            type: 0,
            msgType: 'tips'
          };
          that.VueWebSocket.send(JSON.stringify(msg));
          that.remind.loading = true;
          that.remind.text = '后可用';
          that.remind.timeout = that.remind.initTimeoutSecond;
          clearInterval(that.remind.timer);
          that.remind.timer = setInterval(()=>{
            that.remind.timeout -- ;
            if(that.remind.timeout <= 0){
              clearInterval(that.remind.timer);
              that.remind.loading = false;
              that.remind.text = '提醒对方即将结束';
						}
					},1000)
        }else{
          that.$message.warning('通信未就绪');
				}
      },
      sendMessage() {
        if (this.msgContent.trim().length === 0) {
          this.$message.warning("请先输入内容");
          return false;
        }
        if (this.VueWebSocket && this.VueWebSocket.readyState === 1) {
          let msg = {
            type: 1,
            name: localStorage.name || '',
            content: this.msgContent,
            msgType: 'text'
          };
          this.VueWebSocket.send(JSON.stringify(msg));
          this.msgList = [...this.msgList,msg];
          this.msgContent = '';
        }
        this.renewStayTimer();
      },
      handleChatImgBeforeUpload(file) {
        const vm = this;
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          vm.$message.error("上传图片大小不能超过10M");
          return false;
        } else {
          // 压缩
          //console.log(file)
          base.utils.compress(file, (val) => {
            // 上传
            //console.log('*********val', val)
            let thumbfile = new window.File([val], file.name, {type: file.type});
            // console.log("********thumbfile", thumbfile)

            let formData = new FormData(); // 通过formdata上传
            formData.append('uploadFile', thumbfile);
            this.$ajax.post(base.api.upload.chatImg, formData, {
              headers: {'Content-Type': 'multipart/form-data'}
            }).then((res) => {
              if (res.status === 200 && res.data.status === 'success') {
                if (this.VueWebSocket && this.VueWebSocket.readyState == 1) {
                  let msg = {
                    type: 1,
                    name: localStorage.name || '',
                    content: res.data.message,
                    msgType: 'img'
                  };
                  this.VueWebSocket.send(JSON.stringify(msg));
                  this.msgList = [...this.msgList,msg];
                }
              }
            })
          });
          return false;
        }
      },
      initTRTCCalling() {
        let that = this;
        that.$ajax.post(base.basePath + "medical/appoint/consult/authorize/room/sign/web/" + that.appointId)
          .then(res => {
            if (res.data.status === 'success') {
              that.VueTRTCCalling = new TRTCCalling({
                SDKAppID: res.data.data.sdkAppId //
              });

              that.VueTRTCCalling.setLogLevel(1);

              that.VueTRTCCalling.login({
                userID: res.data.data.userId,
                userSig: res.data.data.userSig,
                privateMapKey: res.data.data.privateMapKey
              });
              // 绑定监听事件
              that.initTRTCListener();
            }
          });
      },
      initTRTCListener() {
        let that = this;
        if (!that.VueTRTCCalling) {
          return;
        }
        that.VueTRTCCalling.on( // 错误处理
          TRTCCalling.EVENT.ERROR,
          that.handleError
        );
        that.VueTRTCCalling.on( // 用户进入
          TRTCCalling.EVENT.USER_ENTER,
          that.handleUserEnter
        );
        that.VueTRTCCalling.on( //用户拒绝
          TRTCCalling.EVENT.REJECT,
          that.handleUserReject
        );
        that.VueTRTCCalling.on(// 用户无应答
          TRTCCalling.EVENT.NO_RESP,
          that.handleUserNoResponse
        );
        that.VueTRTCCalling.on(// 用户忙线
          TRTCCalling.EVENT.LINE_BUSY,
          that.handleUserNoResponse
        );
        that.VueTRTCCalling.on(// 通话结束
          TRTCCalling.EVENT.CALL_END,
          that.handleCallEnd
        );

        // TODO other listener...

      },
      removeListener() {
        let that = this;
        if (!this.VueTRTCCalling) {
          return;
        }
        this.VueTRTCCalling.off( // 错误处理off
          TRTCCalling.EVENT.ERROR,
          that.handleError
        );
        that.VueTRTCCalling.off( // 用户进入off
          TRTCCalling.EVENT.USER_ENTER,
          that.handleUserEnter
        );
        that.VueTRTCCalling.off( //用户拒绝off
          TRTCCalling.EVENT.REJECT,
          that.handleUserReject
        );
        that.VueTRTCCalling.off(// 用户无应答off
          TRTCCalling.EVENT.NO_RESP,
          that.handleUserNoResponse
        );
        that.VueTRTCCalling.off(// 用户忙线off
          TRTCCalling.EVENT.LINE_BUSY,
          that.handleUserNoResponse
        );
        that.VueTRTCCalling.off(// 通话结束
          TRTCCalling.EVENT.CALL_END,
          that.handleCallEnd
        );

      },
      handleError(e) {
        console.error("发生错误: ", e)
      },
      handleUserEnter(e) {
        let that = this;

        let userID = e.userID;
        let doctorID = that.doctorId;

        let lvID = 'lvID-' + Math.random().toString(36).slice(-4);
        let rvID = 'rvID-' + Math.random().toString(36).slice(-4);

        $("#local-video").html('<div id="' + lvID + '"></div>');
        $("#remote-video").html('<div id="' + rvID + '"></div>');

        //$("#local-video").append('<div id="'+lvID+'"></div>');
        //$("#remote-video").append('<div id="'+rvID+'"></div>');

        setTimeout(() => {
          that.VueTRTCCalling.startRemoteView({
            userID,
            videoViewDomID: rvID
          });
          // 开启本地视频
          that.VueTRTCCalling.startLocalView({
            userID: doctorID,
            videoViewDomID: lvID
          });
          that.state = 3;// 通话中
					that.startRecordTime(); // 开始计时
        }, 1000);
      },
      handleUserReject(e) {
        if (this.state == 3) {
          return;
        }
        this.state = 1; // 恢复状态
        this.$messageBox.alert('对方拒绝接听');
      },
      handleUserNoResponse(e) {
        if (this.state == 3) {
          return;
        }
        this.state = 1; // 恢复状态
        this.$messageBox.alert('对方无应答');
      },
      handleCallEnd(e) {
        let that = this;
        that.state = 1;
        this.VueTRTCCalling.logout();
        $("#local-video").html(""); //清空本地视频
        that.$messageBox.alert('对方已结束通话', {
          callback: action => {
            that.reload();
          }
        });
      },

      //TODO  other function  ........

      initWebSocket() {
        let that = this;
        that.$ajax.post(base.api.appoint.consult.roomToken.replace("{id}", that.appointId)).then(res => {
          if (res.data.status === 'success') {
            that.doctorId = res.data.userId;
            let socketUrl = base.api.appoint.consult.socketUrl.replace("{room}", that.appointId).replace("{userId}", res.data.userId);
            that.VueWebSocket = new WebSocket(socketUrl + "?token=" + res.data.token); //校验token
            that.VueWebSocket.onopen = () => {
              // 初始化trtc
              that.initTRTCCalling();
              // 心跳
              that.webSocketHealthInterval = setInterval(() => {
                if (that.VueWebSocket && that.VueWebSocket.readyState == 1) {
                  try {
                    that.VueWebSocket.send(Math.random().toString(36).slice(-4));
                  } catch (e) {
                    console.error(e);
                    clearInterval(that.webSocketHealthInterval); // 停止心跳
                  }
                } else {
                  clearInterval(that.webSocketHealthInterval); // 停止心跳
                  that.userState = 0;
                }
              }, 3000);

              that.VueWebSocket.send('ready');
              that.state = 1; // 已就绪
            };
            that.VueWebSocket.onclose = () => {
              that.destroyTrtc();
              if(that.$route.name == 'chatDoctor'){
                that.$messageBox.alert('会话连接已断开').then(()=>{
                  that.$router.push('/doctor/reservation');
                });
              }
            };
            that.VueWebSocket.onerror = () => {
              that.$message.error("获取用户状态时错误，请刷新页面重试！")
            };
            that.VueWebSocket.onmessage = (e) => {
              let message = e.data;
              if (message === 'ready') { // 医生就绪
                // trtc 等待拨号邀请
                that.userState = 1;
                if (!isNotice) {
                  that.$message.success("对方已就绪!");
                  isNotice = true;
                  clearInterval(this.longStayTimer.timer);
                }
              } else if (message === 'leave') {
                that.userState = 0;
                that.$message.warning('对方已离开');
                isNotice = false;
                this.openStayTimer();
              } else if (message.startsWith("{") && message.endsWith("}")) {// 聊天消息
                /**
                 *
                 * let msg = {
                type: 0,
                msgType: 'result',
                cmd: 'upgrade',
                result: 'accept'
              };
                 *
                 * @type {any}
                 */

                const chatMsg = JSON.parse(message);
                if(chatMsg.type === 0){ // 系统消息
                  if(chatMsg.msgType == 'result'){
                    if(chatMsg.cmd == 'upgrade'){
                      that.applyUpgradeDialog.show = false;
                      that.applyUpgradeDialog.expire = 0;
                      if(that.applyUpgradeDialog.timer){
                        clearInterval(that.applyUpgradeDialog.timer);
                      }
                      if(chatMsg.result == 'accept'){
                        that.$messageBox.alert('对方已同意, 将在3s后重新进入').then(()=>{
                          setTimeout(()=>{
                            location.reload();
                          },3000);
                        })
                      }else if(chatMsg.result == 'reject'){
                        that.$message.info('对方拒绝');
                      }
                    }
                  }
                  return;
                }
                that.msgList = [
                  ...that.msgList,
                  {type: 2, name: that.paitentName, content: chatMsg.content, msgType: chatMsg.msgType || 'text'}
                ]
                that.renewStayTimer();
              }
            };
          }
        }).catch(err => {
          console.error(err);
        })
      },
      callUser() {
        let that = this;
        that.state = 2; // 拨号中
        let type = that.consultMode == 1 ? TRTCCalling.CALL_TYPE.AUDIO_CALL : TRTCCalling.CALL_TYPE.VIDEO_CALL;
        that.VueTRTCCalling.call({
          userID: that.userId,
          type,
          timeout: 0 // 超时时间 : 这里设置70s超时时间，用户端使用60s做处理
        });
      },
      cancelCall() {
        this.VueTRTCCalling.hangup({
          status: 'calling'
        });
        this.state = 1;
      },
      hangupCall() {
        let that = this;
        this.$messageBox.confirm('确定要挂断吗?').then(() => {
          that.VueTRTCCalling.hangup({
            status: 'connected'
          });
          that.state = 1;
          that.resetRecordTime();
        });
      },
			addListenerForUserActive(){ // 添加监听, 监听用户是否离开此页面
        let hidden, state, visibilityChange;
        if (typeof document.hidden !== "undefined") {
          hidden = "hidden";
          visibilityChange = "visibilitychange";
          state = "visibilityState";
        } else if (typeof document.mozHidden !== "undefined") {
          hidden = "mozHidden";
          visibilityChange = "mozvisibilitychange";
          state = "mozVisibilityState";
        } else if (typeof document.msHidden !== "undefined") {
          hidden = "msHidden";
          visibilityChange = "msvisibilitychange";
          state = "msVisibilityState";
        } else if (typeof document.webkitHidden !== "undefined") {
          hidden = "webkitHidden";
          visibilityChange = "webkitvisibilitychange";
          state = "webkitVisibilityState";
        }
				let that = this;
        that.documentHiddenState.hidden = hidden;
        that.documentHiddenState.visibilityChange = visibilityChange;
        that.documentHiddenState.state = state;
            // 添加监听器,监听当前是否活动页面
        document.addEventListener(visibilityChange, that.activeListener, false);
			},
			activeListener(){
        let that = this;
        let isHidden = document[that.documentHiddenState.state] == that.documentHiddenState.hidden;
        if(isHidden){
          that.activeTimeoutTimer = setTimeout(()=>{
            document.removeEventListener(that.documentHiddenState.visibilityChange,that.activeListener,false);
            // 清除trtc
            that.destroyTrtc();
            that.$router.push('/index');
          },that.documentHiddenState.timeout); // 非活动时间
        }else{
          clearTimeout(that.activeTimeoutTimer)
        }
			},
      applyUpgrade(){
        console.log('applyUpgrade');
        let that = this;
        if (that.userState == 0){
          that.$message.warning('对方未就绪!');
          return;
        }
        let id = that.appointId;
        that.$ajax.post(base.basePath + `medical/appoint/consult/authorize/room/apply-upgrade/${id}`).then(res=>{
          if(res.data.status === 'success'){
            // 请求成功, 打开等待窗口
            that.applyUpgradeDialog.expire = res.data.expire;
            if(that.applyUpgradeDialog.timer){
              clearInterval(that.applyUpgradeDialog.timer);
            }
            that.applyUpgradeDialog.timer = setInterval(()=>{
              that.applyUpgradeDialog.expire--;
              if(that.applyUpgradeDialog.expire <= 0){
                clearInterval(that.applyUpgradeDialog.timer);
                that.applyUpgradeDialog.show = false;
              }
            }, 1000);
            // 发送websocket信息
            let msg = {
              type: 0,
              code: res.data.code,
              msgType: 'cmd',
              cmd: 'upgrade',
              expire: res.data.expire
            }
            that.VueWebSocket.send(JSON.stringify(msg));

            that.applyUpgradeDialog.show = true;
          }else{
            that.message.error(res.data.message);
          }
        })

      }
    },
  }
</script>

<style scoped lang="scss">
	@import '../../assets/css/chat.scss';
	.duration-time{
		p{
			line-height: 1.4;
			button{
				padding: 8px 10px;
				font-size: 12px;
				margin-right: 4px;
				width: 120px;
			}
		}
		p.clock{
			text-align: center;
			font-size: 24px;
			margin: 8px 0;
			color:#567BFF
		}
	}
</style>
<style lang="css">
#local-video > div {
	height: 150px;
}
#remote-video > div {
	height: 100%;
}
span.el-image-viewer__btn.el-image-viewer__close{top: 140px}
span.el-image-viewer__btn.el-image-viewer__close i{color: #FFF;}
</style>
